import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { ChangeDetectorRef, Component, OnInit, ViewChild, Optional } from '@angular/core';
import { CdkTableVirtualScrollDataSource } from 'ng-table-virtual-scroll';
import { CookieService } from 'ngx-cookie-service';
import { companiaLista } from 'src/app/interface/CompaniaListaInterface';
import { SseService } from 'src/app/services/SseService';
import { TemaService } from 'src/app/services/tema.services';
import { ConfirmDialogComponent } from '../../common/confirm-dialog/confirm-dialog.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { urlMercado } from 'src/app/utils/mercado-url.util';

@Component({
  selector: 'app-eliminar-lista',
  templateUrl: './eliminar-lista.component.html',
  styleUrl: './eliminar-lista.component.scss'
})
export class EliminarListaComponent implements OnInit {

  public companias = new CdkTableVirtualScrollDataSource<companiaLista>;
  displayedColumns: string[] = ['n', 'iso', 'descripcion', 'tipo'];
  @ViewChild('eliminarComp', { static: false }) eliminarCompViewport!: CdkVirtualScrollViewport;
  token: string;
  listaMercado: any;
  theme: string;
  selectedValue: any;

  constructor(private _sseservice: SseService, private _cookieService: CookieService, 
  public temaservicio: TemaService,private cdr: ChangeDetectorRef, public dialog: MatDialog,
  @Optional() public dialogRef: MatDialogRef<EliminarListaComponent>,
     private toastr: ToastrService,
    ){}

  ngOnInit(): void {
    this.token = this._cookieService.get('auth_token');
    this.temaservicio.valDarkTheme.subscribe(data => {
      this.theme = data ? 'dark-theme' : 'light-theme';
    });
    this.listarMercados();
  }

  listarMercados(){
    this._sseservice.apiPostNew("listamercadosporusuario", {}, this.token).subscribe({
      next: (data: any) => {
        console.log(data);
        this.listaMercado = data;
      }
    });
  }

  
  buscarCompania() {
    const jsonData = {
      idmercado: this.selectedValue
    };
    this._sseservice.apiPostNew('listadecompaniaspormercado', jsonData, this.token).subscribe({
      next: (data: any) => {
        this.companias = new CdkTableVirtualScrollDataSource(data);
        this.actualizarViewport();
      }
    });
  }

  EliminarLista(){
    let url='eliminarlista';
    if(this.selectedValue>0){
      const jsonData = {
        idmercado: this.selectedValue
      };
      console.log(this.theme);
      const confirmar = this.dialog.open(ConfirmDialogComponent, {
        width: '380px',
        height: '200px',
        panelClass: this.theme,
        data: {
          msj: 'Esta Seguro que desea Eliminar la Lista'
        }
      });
      confirmar.afterClosed().subscribe(result => {

        if (result) {
          this._sseservice.apiPostNew(url, jsonData, this.token).subscribe({
            next: (data: any) => {
                if(data.status){
                  this.toastr.success(data.msg, 'OK', { timeOut: 7000, positionClass: 'toast-top-center' });
                  this.selectedValue = null;
                  this.companias = new CdkTableVirtualScrollDataSource<companiaLista>([]);
                  this.listarMercados();
                }else if(data.enUso){
                  const carteras: any[] = data.carteras ?? [];
                  const nombres = carteras.slice(0, 5).map(c => `${c.cartera} (modelo ${c.idmodelo})`).join(', ');
                  const resto = carteras.length > 5 ? ` y ${carteras.length - 5} más` : '';
                  this.toastr.error(`${data.msg}: ${nombres}${resto}`, 'Error', { timeOut: 10000, positionClass: 'toast-top-center' });
                }else{
                  this.toastr.error(data.msg, 'Error', { timeOut: 7000, positionClass: 'toast-top-center' });
                }
              if (this.dialogRef) {
                this.dialogRef.close();
              }
            }
          });
        } else {
          // Lógica a ejecutar si se cancela la acción
          console.log('La acción fue cancelada');
        }
      });
    }else{
      const dialogConfirm = this.dialog.open(ConfirmDialogComponent, {
        width: '380px',
        height: '200px',
        panelClass: this.theme,
        data: {
          msj: 'Debe Seleccionar un Mercado para eliminar'
        }
      });
    }

  }

  actualizarViewport() {
    this.eliminarCompViewport.checkViewportSize();
    this.eliminarCompViewport.checkViewportSize();
    this.cdr.detectChanges();
  }

  /** Abre el activo en /mercados dentro del mercado seleccionado. */
  urlMercadoActivo(element: any): string {
    if (!this.selectedValue) { return '/mercados'; }
    const mercado = this.listaMercado?.find((m: any) => m.idmercado == this.selectedValue) ?? { idmercado: this.selectedValue };
    return urlMercado(mercado, element.iso ?? '');
  }
}
